/**
 * Product card fabric swatches: seeded shuffle so each product shows 4 different picks,
 * and a per-card "+N" value (1..min(14, extras)) from the same seed stream.
 */
(function () {
  const SEL_ROOT = ".fabric-preview--async";
  const SEL_JSON = "script.fabric-preview__json";

  function mulberry32(seed) {
    return function () {
      let t = (seed += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function mixSeed(productId, gridPos) {
    let h = (Number(productId) || 0) ^ Math.imul(Number(gridPos) || 0, 0x9e3779b9);
    h = Math.imul(h ^ (h >>> 16), 0x21f0aaad);
    h = Math.imul(h ^ (h >>> 15), 0x735a2d97);
    return (h ^ (h >>> 15)) >>> 0;
  }

  function shuffle(arr, rand) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }

  function syncFabricActive(root) {
    root.querySelectorAll("label.fabric-dot").forEach((label) => {
      const input = label.querySelector("input.fabric-preview__radio");
      label.classList.toggle("active", !!(input && input.checked));
    });
  }

  function selectFabricRadio(input) {
    const root = input.closest(".fabric-preview");
    if (!root) return;
    root.querySelectorAll("input.fabric-preview__radio").forEach((r) => {
      r.checked = r === input;
    });
    syncFabricActive(root);
  }

  function bindFabricPreview(root) {
    if (root.dataset.fabricBound === "1") return;
    root.dataset.fabricBound = "1";

    root.addEventListener("change", (e) => {
      if (e.target.matches && e.target.matches("input.fabric-preview__radio")) {
        syncFabricActive(root);
      }
    });

    root.addEventListener(
      "click",
      (e) => {
        const label = e.target.closest(".fabric-dot");
        if (!label || !root.contains(label)) return;
        const input = label.querySelector("input.fabric-preview__radio");
        if (!input) return;
        selectFabricRadio(input);
      },
      true
    );
  }

  function initRoot(root) {
    if (root.dataset.fabricInited === "1") return;
    const scriptEl = root.querySelector(SEL_JSON);
    if (!scriptEl || scriptEl.type !== "application/json") return;

    let data;
    try {
      data = JSON.parse(scriptEl.textContent.trim());
    } catch {
      return;
    }
    scriptEl.remove();

    const name = data.n;
    const pool = Array.isArray(data.p) ? data.p : [];
    const productUrl = data.u || "#";
    const seed = mixSeed(data.s, data.g);

    if (!name || pool.length === 0) return;

    const rand = mulberry32(seed);
    const shuffled = shuffle(pool, rand);
    const limit = Math.min(4, shuffled.length);
    const pick = shuffled.slice(0, limit);

    const parts = [];
    for (let i = 0; i < pick.length; i++) {
      const entry = pick[i];
      const url = entry[0];
      const handle = entry[1] || "";
      const id = `${name}-${i}`;
      const checked = i === 0 ? " checked" : "";
      parts.push(
        `<label class="fabric-dot">` +
          `<input type="radio" class="sr-only fabric-preview__radio" name="${escapeAttr(name)}" id="${escapeAttr(id)}" value="${escapeAttr(handle)}"${checked}>` +
          `<img src="${escapeAttr(url)}" alt="" width="200" height="200" loading="lazy">` +
          `</label>`
      );
    }

    const extras = pool.length - limit;
    if (extras > 0) {
      const cap = Math.min(14, extras);
      var plusNum = 1 + Math.floor(rand() * cap);
      if (plusNum < 9 ) {
        var plusNum = plusNum + 10;
      }
      parts.push(
        `<a href="${escapeAttr(productUrl)}" class="fabric-more-link">+${plusNum}</a>`
      );
    }

    root.innerHTML = parts.join("");
    root.querySelectorAll("input.fabric-preview__radio").forEach((el, i) => {
      el.checked = i === 0;
    });
    syncFabricActive(root);
    bindFabricPreview(root);
    root.dataset.fabricInited = "1";
  }

  function run() {
    document.querySelectorAll(SEL_ROOT).forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
})();
